<template>
  <div class="hd-TopMenu_Item">
    <button
      @click="toggleShowOverlay"
      class="hd-TopMenu_Link hd-TopMenu_MainLink btn btn-reset shadow-none"
      type="button"
    >
      <div class="position-relative hd-TopMenu_Icon">
        <i class="icon icon-cart hd-TopMenu_Icon pr-1"></i>
        <span v-if="itemsInShoppingCart" class="badge badge-pill hd-TopMenu_CartCount">{{
          itemsInShoppingCart
        }}</span>
      </div>
      <span class="hd-TopMenu_LinkLabel">
        {{ translations.cart }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ShoppingCartButton",
  props: {
    translations: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getAllLineItems: "shoppingCart/getAllLineItems",
    }),
    itemsInShoppingCart() {
      return this.getAllLineItems.reduce((sum, lineItem) => sum + lineItem.quantity, 0);
    },
  },
  mounted() {
    this.fetchAllLineItems();
  },
  methods: {
    ...mapActions({
      fetchAllLineItems: "shoppingCart/fetchAllLineItems",
      toggleShowOverlay: "shoppingCart/toggleShowOverlay",
    }),
  },
};
</script>
